import { useState } from "react";
import CountdownComponentSimple from "../CountdownComponentSimple";

export default function TiempoValidez({classTop = "", data, onComplete}){
    const [currentTime, setCurrentTime] = useState(data.currentTime)
    const [clientTime, setClientTime] = useState(data.clientTime)

    return (
        <div className={`tiempo-validez ${classTop}`}>
            <div className="d-flex">
                <div className="flex-grow-1">
                    <span className="colorLabel">Tiempo de validez</span>
                </div>
                <div className="vl mx-2"></div>
                <div>
                    <span className="colorLabel">
                        <CountdownComponentSimple 
                            date={data.startMeeting.toDate()} 
                            serverTime={currentTime}
                            setServerTime={setCurrentTime}
                            clientTime={clientTime}
                            setClientTime={setClientTime}
                            onComplete={onComplete}
                        />
                    </span>
                </div>
            </div>
        </div>
    )
}